const lazy = {
    loadedCount: 0,
    totalImages: 0,
    init() {
        const lazyImages = document.querySelectorAll('img[loading="lazy"]');
        this.totalImages = lazyImages.length;

        lazyImages.forEach((img) => {
            if (img.complete) {
                this.loadImage(img);
            } else {
                img.addEventListener('load', () => {
                    this.loadImage(img);
                });
            }
        });
    },
    loadImage(img) {
        if (img.complete) {
            this.loadedCount++;
            img.classList.add('lazy-loaded');
        }
    }
}

export default lazy;
